import PlanRank from './PlanRank'
export default PlanRank
